import { ButtonAnchor } from "@components/Buttons"
import LooksCard from "@components/Cards/LooksCard"
import { useIntl } from "@components/Intl"
import IntlLink from "@components/Intl/IntlLink"
import { Box } from "@components/Layout"
import { breakpoints } from "@config/theme"
import { getKontentImage } from "@lib/kontent"
import { LookDetailPage } from "@lib/kontent/models-deprecated/look_detail_page"
import React from "react"
import styled from "styled-components"

const Grid = styled(Box)`
  @media screen and (min-width: ${breakpoints.small}) {
    columns: 2;
  }
`

interface Props {
  items: LookDetailPage[]
}

const ratios = [
  ["100%", "85%"],
  ["100%", "100%"],
  ["100%", "100%"],
  ["100%", "85%"],
]

const OtherLooks: React.FC<Props> = ({ items }) => {
  const { messages } = useIntl()

  return (
    <>
      <Grid
        display={["grid", "block"]}
        gridTemplateColumns="repeat(2, 1fr)"
        gridColumnGap={[0, ".75rem", "1.5rem"]}
        gridRowGap={["1rem", 0]}
        my={"3.5rem"}
        position="relative"
      >
        {items.map((item, index) => {
          if (!item) {
            return null
          }
          const isOdd = index % 2 === 0
          const horizontalImg = getKontentImage(
            item.horizontalImage.value[0]?.url,
            {
              width: 700,
            }
          )
          const verticalImg = getKontentImage(
            item.verticalImage.value[0]?.url,
            { width: 700 }
          )

          return (
            <Box position="relative" key={item.system.id}>
              <LooksCard
                gridColumn={"span 2"}
                ratio={ratios[index]}
                image={isOdd ? horizontalImg : verticalImg}
                href="/looks/[uid]"
                as={`/looks/${item.urlSlug.value}`}
              >
                <></>
              </LooksCard>
            </Box>
          )
        })}
      </Grid>

      <Box
        display="flex"
        justifyContent={["center"]}
        width="100%"
        position={["relative"]}
        bottom={0}
        right={0}
        pb="5"
      >
        <IntlLink href="/looks" as="/looks">
          <ButtonAnchor href="/looks" variant="purple-border" maxWidth={250}>
            {messages.lookDetail.viewAll}
          </ButtonAnchor>
        </IntlLink>
      </Box>
    </>
  )
}

export default OtherLooks
